module.exports = __webpack_public_path__ + "img/resolution.b4c5b7bb.jpg";